/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/798/interface/api/cat_7765
 */

import { message } from 'ant-design-vue'
import {
  collection_list_post,
  config_set_post,
  site_list_get,
  userGroup_list_get
} from 'server/modules/7765'

// collection列表
export const collection_list_post_ = async function(params) {
  const { success, data, retInfo } = await collection_list_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 配置设置
export const config_set_post_ = async function(params) {
  const { success, data, retInfo } = await config_set_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 站点列表（组合id）
export const site_list_get_ = async function(params) {
  const { success, data, retInfo } = await site_list_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 获取用户群列表
export const userGroup_list_get_ = async function(params) {
  const { success, data, retInfo } = await userGroup_list_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}
